/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Teleport           from 'vue2-teleport';
import Field              from 'components/Field.vue';
import { toRawType }      from 'utils/toRawType';
import { getUniqueDomId } from 'utils/getUniqueDomId';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: "field-image",

  props: ['state'],
  data() {
    return {
      id:     getUniqueDomId(),
      active: null,
      value:  undefined !== this.state.value.mime_type ? this.state.value.value : this.state.value,
    }
  },
  components: {
    Field,
    Teleport,
  },
  computed: {
    images() {
      return [].concat(this.value).map(img => ({ src: (img || {}).photo || img }));
    },
  },
  methods: {
    async showGallery(index) {
      this.active = index;
      if (toRawType(this.value) === 'Object') {
        this.value.active = true;
      }
      $(`#gallery_${this.id}`).modal('show');
    },
    isRelativePath(url) {
      if (!url.startsWith('/') && !url.startsWith('http')) {
        return `${window.initConfig.mediaurl}${url}`;
      }
      return url;
    },
  }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{attrs:{"state":_vm.state}},[_c('div',{staticStyle:{"text-align":"left","display":"inline-block"},attrs:{"slot":"field"},slot:"field"},[_vm._l((_vm.images),function(img,i){return _c('img',{staticClass:"img-responsive",staticStyle:{"max-height":"50px"},attrs:{"src":img.src},on:{"click":function($event){$event.stopPropagation();return _vm.showGallery(i)}}})}),_vm._v(" "),_c('Teleport',{attrs:{"to":"body"}},[_c('div',{staticClass:"modal fade modal-fullscreen",attrs:{"id":("gallery_" + _vm.id),"tabindex":"-1","role":"dialog","aria-labelledby":"","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"carousel slide",attrs:{"id":("carousel_" + _vm.id),"data-interval":"false"}},[_c('div',{staticClass:"carousel-inner"},_vm._l((_vm.images),function(image,i){return _c('div',{staticClass:"item",class:_vm.active == i ? 'active' : ''},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":_vm.isRelativePath(image.src),"alt":""}})])}),0),_vm._v(" "),(_vm.images.length > 1)?_c('a',{staticClass:"left carousel-control",attrs:{"href":("#carousel_" + _vm.id),"role":"button","data-slide":"prev"}},[_c('span',{class:_vm.$fa('arrow-left')})]):_vm._e(),_vm._v(" "),(_vm.images.length > 1)?_c('a',{staticClass:"right carousel-control",attrs:{"href":("#carousel_" + _vm.id),"role":"button","data-slide":"next"}},[_c('span',{class:_vm.$fa('arrow-right')})]):_vm._e()])])])])])])],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6ae7d977_0", { source: ".img-responsive[data-v-6ae7d977]{cursor:pointer}.modal-content[data-v-6ae7d977]{background:rgba(255,255,255,.6);border-radius:3px}.modal-dialog[data-v-6ae7d977]{display:inline-block;text-align:left;vertical-align:middle}.modal[data-v-6ae7d977]{text-align:center;padding:0!important}.modal[data-v-6ae7d977]:before{content:'';display:inline-block;height:100%;vertical-align:middle;margin-right:-4px}.carousel .carousel-control span[data-v-6ae7d977]{color:#3c8dbc;position:absolute;top:50%}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-6ae7d977"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FieldImage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__